const pick = (keys, object) =>
    Object.entries(object).reduce(
        (acc, [key, value]) => (keys.includes(key) ? { ...acc, [key]: value } : acc),
        {},
    );

const parse = x => JSON.parse(JSON.stringify(x));

export function objectEquals(x, y) {
    'use strict';

    if (x === null || x === undefined || y === null || y === undefined) { return x === y; }
    // after this just checking type of one would be enough
    ////if (x.constructor !== y.constructor) { return false; }
    // if they are functions, they should exactly refer to same one (because of closures)
    ////if (x instanceof Function) { return x === y; }
    if (x instanceof Function) return true;
    // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)
    if (x instanceof RegExp) { return x === y; }
    if (x === y || x.valueOf() === y.valueOf()) { return true; }
    if (Array.isArray(x) && x.length !== y.length) { return false; }

    // if they are dates, they must had equal valueOf
    if (x instanceof Date) { return false; }

    // if they are strictly equal, they both need to be object at least
    if (!(x instanceof Object)) { return false; }
    if (!(y instanceof Object)) { return false; }

    // recursive object equality check
    var p = Object.keys(x).filter(k => !k.startsWith("_"));
    return Object.keys(y)
        .filter(k => !k.startsWith("_"))
        .every(function (i) { return p.indexOf(i) !== -1; }) &&
        p.every(function (i) { return objectEquals(x[i], y[i]); });
}

function proxySubling(x) {
    Object.keys(x).every(key => {
        if (!key.startsWith("_")) {
            if (Array.isArray(x[key])) {
                proxySubling(x[key])
            } else if (x[key] instanceof Object) {
                x[key] = proxy(x[key])
                proxySubling(x[key])

            }
        }
        return true;
    })
}

export default function proxy(initialAttrs = {}) {
    let current = parse(initialAttrs);
    let original = parse(initialAttrs);

    const utils = {

        isChanged: (key = null) => {
            /*
            let compare = function(c, o) {
                [...Object.keys(c), Object.keys(o)]
                .filter((value, index, self) => {
                    return self.indexOf(value) === index
                })
                .some(key => {
                    let cur = current[key];
                    let orig = original[key];
                    if (Array.isArray(cur) && Array.isArray(orig)) { 
                        if (cur.length !== orig.length) {
                            return false;
                        } else {
                            return compare(cur, orig);
                        } 
                    }
                    if ((cur instanceof Object) && (orig instanceof Object)) {
                        return compare(cur, orig);
                    }
                    return cur !== orig
                })    
            }
    */
            return key ? !objectEquals(current[key], original[key]) : !objectEquals(current, original)
        },

        getCurrent: () => {
            return current
        },

        getOriginal: () => {
            return original
        },

        undo: () => {
            Object.assign(current, parse(original));
            proxySubling(current);
        },

        applyChanged: newOriginal =>
            Object.assign(original, parse(pick(Object.keys(original), newOriginal))),
    };

    proxySubling(current);
    return new Proxy(current, {
        get: (obj, prop) => {
            if (prop in utils) {
                return utils[prop];
            }
            if (prop in obj) {
                return obj[prop];
            } else {
                return false;
            }
        },
        set: (obj, prop, value) => {
            //if (prop.startsWith("_")) {
            //    return ((obj[prop] = value) || true)
            //}
            return prop in obj && ((obj[prop] = value) || true)
        },
    });
}